import request from '@/utils/request'



export function getRunFotMoneyList(data) {
  return request({
    url: 'api/v1/run-for-money/list',
    method: 'post',
    data: data
  })
}

export function importRunFotMoneyCfg(data) {
  return request({
    url: 'api/v1/run-for-money/import',
    method: 'post',
    data: data
  })
}

export function runFotMoneyBaseConf(data) {
  return request({
    url: 'api/v1/run-for-money/base',
    method: 'post',
    data: data
  })
}

export function saveRunFotMoneyBaseConf(data) {
  return request({
    url: 'api/v1/run-for-money/saveBase',
    method: 'post',
    data: data
  })
}

export function delRunFotMoneyConf(data) {
  return request({
    url: 'api/v1/run-for-money/delete',
    method: 'post',
    data: data
  })
}
